/** 方案檻次 */
export enum ProgramThreshold {
  /** 累進制 */
  PROGRESSIVE = 'P',
  /** 達標制 */
  STANDARD = 'S',
  /** 不設定門檻 */
  NOT_SET = 'N'
}
